module.exports = {
	INIT_APP: 'init_app',
	SET_NETWORK: 'set_network',
	SET_HASWALLET: 'set_haswallet',
	SET_WALLET: 'set_wallet',
	SET_SCCANNED_DATA: 'set_scanned_eth_address',
	SET_APP_PASSCODE: 'set_app_passcode',
	SET_SENDING_TOKEN_NAME: 'set_sending_token_name',
	SET_ETH_BALANCE: 'set_eth_balance'
};
